<template>
  <users-list></users-list>
</template>

<script>
import UsersList from "../../../components/Settings/Users/UsersList";
export default {
  name: "AdminUsersView",
  components: { UsersList }
};
</script>

<style scoped></style>
